import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element, ...rest }) => {
    const isAuthenticated = sessionStorage.getItem("isAuthenticated");
    return isAuthenticated ? element : <Navigate to="/adminlogin" />;
};

export default PrivateRoute;
